export interface Product {
  id: string;
  name: string;
  price: number;
  imageUrls: string[];
  status: "ready" | "pending";
  deliveryTime: string;
  category: string[];
  tags: string[];
  size: string;
  description: string;
  cantidad: number;
  enabled: boolean;
}

export interface Category {
  id: string;
  name: string;
}

export const getStatusText = (status: "ready" | "pending"): string => {
  return status === "ready" ? "Ya listo" : "Sin resina";
};

export const getStatusDescription = (status: "ready" | "pending"): string => {
  if (status === "ready") {
    return "El cuadrito está completamente terminado con la resina aplicada y seca. Puede ser entregado inmediatamente después de la compra.";
  } else {
    return "La imagen ya está aplicada en la madera, pero aún falta aplicar la resina y esperar a que seque. Este proceso tomará aproximadamente de 2 a 3 días adicionales antes de que el cuadrito esté listo para entrega.";
  }
};
